import React, { useEffect, useState, useLayoutEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import helpers from "@sistemas.mundo/helper-functions";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

import {
  Button,
  Grid,
  Paper,
  Tooltip,
  Box,
  ButtonGroup,
  useMediaQuery,
  Fab,
  Pagination,
  ListItem,
  ListItemIcon,
  ListItemText,
  Alert,
  Checkbox,
  Link,
} from "@mui/material";
import CustomModal from "@sistemas.mundo/custom-modal";
import CustomForm from "@sistemas.mundo/custom-form";
import AddIcon from "@mui/icons-material/Add";
import { getFilterParams, validateShowOptionMenu } from "./customTableHelpers";
import FilterSection from "./components/FilterSection/FilterSection";
import SimplePagination from "./components/SimplePagination/SimplePagination";

/**
 * Query filters disponibles: id, openModalIngresar = 1
 * @param {*} param0
 * @returns
 */
const CustomTable = ({
  queryData,
  tableRows,
  tableHeaders,
  queryIngresar = null,
  queryActualizar = null,
  tableActions = null,
  camposFilter = null,
  rowsPerPage = 5,
  camposFormulario,
  filterSeccionTitle = "Filtros",
  titleModalIngresar = "",
  titleModalEditar = "",
  titleBtnIngresar = "Ingresar",
  showBtnIngresar = false,
  showExportBtn = false,
  titleExport = "Exportar a excel",
  onClickExportExcel = null,
  isExpandedFilters = true,
  filterButtonText = "Filtrar",
  tooltipFilterBtn = "Aplicar filtros",
  isOpenModalIngresar = false,
  isOpenModalEditar = false,
  itemSelectedEditar = null,
  onCloseModalEditarInsertar = null,
  handleOnSubmitFilter = null,
  hanleOnClickGuardarIngresar = null,
  hanleOnClickGuardarEditar = null,
  closeModalIngresarOnSucces = false,
  closeModalEditarOnSucces = false,
  resetFormIngresarOnSubmit = true,
  resetFormEditarOnSubmit = false,
  showFilterSection = false,
  hasCheckbox = false,
  clearCheckBoxOnRefetch = true,
  onChangeCheckbox = null,
  refetchData = null,
  preventSubmitOnFilter = false,
  titleIconFilter = "Filtros",
  handleDeshacerFilter = null,
  showTotalItems = true,
  simplePaginate = false,
  orderByFilter = false,
  handleBackResetFormEditarIngresar = null,
  forceMinFilters = false,
  minFiltersToIgnore = [],
  filtrosSave = false,
  hasDefaultData = false,
  tableId = "",
  paginate = true,
}) => {
  const querystring = window.location.search;
  const variables = new URLSearchParams(querystring);
  const matches = useMediaQuery("(min-width:600px)");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [currentCamposFilter, setCurrentCamposFilter] = useState(camposFilter);
  const [paginationOptions, setPaginationOptions] = useState({
    perPage: rowsPerPage,
    currentPage: 1,
  });
  const [resetFormOnSubmit, setResetFormOnSubmit] = useState({
    ingresar: null,
    editar: null,
  });
  const [countItems, setCountItems] = useState(0);
  const [countPages, setCountPages] = useState(0);
  const [selectedItem, setSelectItem] = useState(itemSelectedEditar);
  const [changedFormEdit, setChangedFormEdit] = useState(hasDefaultData);
  const [openModalIngresar, setOpenIngresarModal] =
    useState(isOpenModalIngresar);
  const [openModalEditar, setOpenEditarModal] = useState(isOpenModalEditar);
  const [expandedFilters, setExpandedFilters] = useState(isExpandedFilters);
  const [modalSeHaAbierto, setModalSeHaAbierto] = useState(false);
  const [filtrado, setFiltrado] = useState(false);
  const [filterParams, setFilterParams] = useState(
    getFilterParams(
      camposFilter,
      paginationOptions.currentPage,
      rowsPerPage,
      null,
      variables.get("id") ?? ""
    )
  );
  const [selected, setSelected] = useState({});
  const query = queryData();
  const [showModalFilter, setShowModalFilter] = useState(false);
  const [showSimplePagination, setShowSimplePagination] =
    useState(simplePaginate);
  const [size, setSize] = useState([0, 0]);
  const mobileScreenSize = 600;
  const [queryListData, setQueryListData] = useState(null);

  useEffect(() => {
    query.mutate(filterParams);
  }, [tableId]);

  useEffect(() => {
    if (
      query.isSuccess &&
      !query.data.error /* && (query.data.success || query.data) */
    ) {
     
      setQueryListData(query);

      setCountPages(
        query.data.success?.descripcionRespuesta?.last_page ??
          query.data.last_page
      );
      setCountItems(
        query.data.success?.descripcionRespuesta?.total ?? query.data.total
      );
    }
  }, [query.isSuccess]);

  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  useEffect(() => {
    if (refetchData && filtrosSave) {
      setFiltrado(true);
      queryListData.refetch();
    }
    if (refetchData && !filtrosSave) {
      setFiltrado(true);
      setFilterParams(
        getFilterParams(
          camposFilter,
          paginationOptions.currentPage,
          rowsPerPage,
          null,
          variables.get("id") ?? ""
        )
        /* () => {
          queryListData.refetch();
        } */
      );
    }
  }, [refetchData]);

  useEffect(() => {
    setOpenIngresarModal(isOpenModalIngresar);
  }, [isOpenModalIngresar]);

  useEffect(() => {
    if (hasDefaultData) {
      setChangedFormEdit(hasDefaultData);
    }
  }, [hasDefaultData]);

  useEffect(() => {
    setFilterParams({
      ...filterParams,
      page: paginationOptions.currentPage,
      perPage: paginationOptions.perPage,
    });
  }, [paginationOptions]);

  /* useEffect(() => {
    if (queryListData && queryListData.data && queryListData.data.data) {
      if (!simplePaginate || !showSimplePagination) {
        setCountPages(queryListData.data.success.descripcionRespuesta.last_page);
        setCountItems(queryListData.data.success.descripcionRespuesta.total);
      }
    }
  }, [queryListData && queryListData.data]); */

  useEffect(() => {
    if (hasCheckbox && clearCheckBoxOnRefetch && queryListData.isRefetching) {
      setSelected({});
    }
  }, [queryListData?.isRefetching]);

  useEffect(() => {
    if (filtrado && queryListData) {
      queryListData.mutate(filterParams);
    }
  }, [filterParams]);

  /**
   * Se encarga de validar cuando se haya ejecutado el guardar y editar
   */

  useEffect(() => {
    if (
      queryIngresar &&
      queryIngresar.isSuccess &&
      queryIngresar.data.success
    ) {
      setResetFormOnSubmit({
        ...resetFormOnSubmit,
        ingresar: resetFormIngresarOnSubmit,
      });
      if (resetFormIngresarOnSubmit) {
        //resetea el valor a null para que la proxima vez actualice el contexto
        setResetFormOnSubmit({
          ...resetFormOnSubmit,
          ingresar: null,
        });
      }
      if (closeModalIngresarOnSucces) {
        setOpenIngresarModal(false);
        if (onCloseModalEditarInsertar) {
          onCloseModalEditarInsertar();
        }
      }

      queryIngresar.reset();
    }

    if (
      queryActualizar &&
      queryActualizar.isSuccess &&
      queryActualizar.data.success
    ) {
      setResetFormOnSubmit({
        ...resetFormOnSubmit,
        editar: resetFormEditarOnSubmit,
      });
      if (resetFormEditarOnSubmit) {
        //resetea el valor a null para que la proxima vez actualice el contexto
        setResetFormOnSubmit({
          ...resetFormOnSubmit,
          editar: null,
        });
      }
      if (closeModalEditarOnSucces) {
        setOpenEditarModal(false);
      }
      queryActualizar.reset();
    }
  }, [
    queryIngresar ? queryIngresar.isLoading : null,
    queryActualizar ? queryActualizar.isLoading : null,
  ]);

  /**
   * Se encarga de validar si los nuevos campos ingresados en el formulario han cambiado
   * Comparando los campos actuales del formulario con los datos del item seleccionado (caso editar) o con los valores por defecto del formulario (caso ingresar)
   * @param {*} formData
   * @param {*} defaultFormData
   */
  const getFormValues = (formData, defaultFormData) => {
    if (formData) {
      let newObj = helpers.object.cloneObjectArray(formData);
      Object.entries(newObj).forEach(([key, value]) => {
        if (defaultFormData) {
          if (
            defaultFormData[key] &&
            helpers.date.isValidDate(defaultFormData[key])
          ) {
            defaultFormData[key] = helpers.date.formatDate(
              defaultFormData[key],
              "YYYY/MM/DD"
            );
          } else if (defaultFormData[key] && defaultFormData[key].id) {
            defaultFormData[key] = defaultFormData[key].id;
          }
        }
        if (formData[key]) {
          if (helpers.date.isValidDate(formData[key])) {
            formData[key] = helpers.date.formatDate(
              formData[key],
              "YYYY/MM/DD"
            );
          } else if (formData[key].id) {
            formData[key] = formData[key].id;
          }
        }
        newObj[key] = defaultFormData[key];
      });
      setChangedFormEdit(!helpers.object.isEqual(newObj, formData));
    }
  };

  /**
   * Retorna el contenido que contendra el body
   * @param {*} onSubmitFunction
   * @param {*} campo -- valores por defecto que tendrá el formulario
   * @returns
   */

  const getBodyModal = (onSubmitFunction, campo = null) => {
    return (
      <CustomForm
        resetCamposOnSubmit={
          campo ? resetFormOnSubmit.editar : resetFormOnSubmit.ingresar
        }
        formId={campo ? "formEditar" : "formIngresar"}
        onSubmit={onSubmitFunction}
        getForValues={(item1, item2) => getFormValues(item1, item2)}
        campos={camposFormulario(campo)}
        submitButtonPosition="right"
        handleBackResetForm={handleBackResetFormEditarIngresar}
      />
    );
  };

  const onClickActionEditar = (campo) => {
    setOpenEditarModal(true);
    setSelectItem(campo);
    setModalSeHaAbierto(true);
  };

  /**
   * Determina la alineación de la celda
   * @param {*} row
   * @returns
   */
  const getRowCellPostion = (row) => {
    if (!row.position) {
      if (row.type) {
        switch (row.type) {
          case "number":
            return "right";
          case "date":
          case "text":
            return "left";
          default:
            return "left";
        }
      }
      return "left";
    }
    return row.position;
  };

  /**Retorna el valor formateado segun el tipo de dato */
  const getRowCellFormatValue = (row, data) => {
    let value = data[row.name];
    if (row.type) {
      switch (row.type) {
        case "currency":
          return helpers.currencys.formatterPeso.format(value);
        case "date":
          return helpers.date.formatDate(value);
        default:
          return value;
      }
    }
    return row.draw ? row.draw(data) : value; // agrega al objecto principal campos que se quiere
  };

  const getTableRows = () => {
    const { data } = query.data?.success?.descripcionRespuesta ?? query.data;
    let result = [];
    if (data && Array.isArray(data)) {
      data.forEach((x, key) => {
        const cell = [];
        if (hasCheckbox) {
          cell.push({
            data: (
              <Checkbox
                color="primary"
                name={`row_${key}`}
                onChange={(event) => handleSelectRow(event, x)}
                checked={selected[`row_${key}`]?.checked ?? false}
              />
            ),
          });
        }
        tableRows.map((row) => {
          let data = getRowCellFormatValue(row, x);
          cell.push({
            data: data,
            backgroundColor: x?.backgroundColor ?? "",
            color: x?.color ?? "",
            position: getRowCellPostion(row),
            onClick: (data !== row.defaultValue && row?.onClick) ?? null,
            underline: (data !== row.defaultValue && row?.underline) ?? null,
            tooltip: row.tooltip ?? null,
          });
        });
        cell.push({
          data: getTableActions(x, key),
          backgroundColor:
            tableActions && Array.isArray(tableActions[0]?.opciones)
              ? tableActions[0]?.opciones[key]?.backgroundColor ?? ""
              : "",
          color:
            tableActions && Array.isArray(tableActions[0]?.opciones)
              ? tableActions[0]?.opciones[key]?.color ?? ""
              : "",
          position: "center",
        });
        result.push(cell);
      });
    }
    return result;
  };

  /* Metodo que selecciona un checkbox */
  const handleSelectRow = (event, row) => {
    setSelected({
      ...selected,
      [event.target.name]: { checked: event.target.checked, item: row },
    });
  };

  /* useEffect que vigila el estado con los datos
  para poder usarlos a penas se cambia la seleccion del checkbox */
  useEffect(() => {
    const obtenerSeleccionados = (selectedRows) => {
      return Object.entries(selectedRows)
        .filter(([key, row]) => {
          if (row.checked) {
            return row;
          }
        })
        .map((item) => {
          return item[1].item;
        });
    };

    if (hasCheckbox && !_.isEmpty(selected)) {
      let selectedRows = obtenerSeleccionados(selected);
      if (onChangeCheckbox) {
        onChangeCheckbox(selectedRows);
      }
    } else {
      if (onChangeCheckbox) {
        onChangeCheckbox([]);
      }
    }
  }, [selected]);

  const handleClick = (event, index) => {
    setAnchorEl({ [index]: event.currentTarget });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  /**
   * Retorna la lista de acciones que contiene el menu (icon button con 3 puntos) de fila de la tabla
   * @param {*} action
   * @param {*} item
   * @returns
   */
  const getActionMenuTable = (action, item) => {
    if (!item.id) {
      item.id = item[action.id];
    }

    if (action.opciones) {
      const opciones = action.opciones.filter((x) => {
        if (validateShowOptionMenu(x, item)) {
          return x;
        }
        if (
          !x.hasOwnProperty("showIf") &&
          !x.hasOwnProperty("showIfNot") &&
          !x.hasOwnProperty("visible")
        ) {
          return x;
        }
      });

      return (
        <div key={`${item.id}`} id={`${item.id}`}>
          <Tooltip
            title={
              <div style={{ fontSize: "120%" }}>
                No hay acciones disponibles...
              </div>
            }
            disableHoverListener={opciones.length !== 0}
          >
            <span>
              <IconButton
                aria-label="more"
                id={`iconMenuId${item.id}`}
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                disabled={opciones.length === 0}
                onClick={(e) => {
                  handleClick(e, item.id);
                }}
              >
                <MoreVertIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Menu
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={anchorEl && anchorEl[item.id]}
            open={open && anchorEl && Boolean(anchorEl[item.id])}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: 48 * 4.5,
                width: "auto",
              },
            }}
          >
            {opciones.map((option, key) => (
              <ListItem
                button
                key={`menuOptionAction${item.id}_${key}`}
                id={`menuOptionAction${item.id}_${key}`}
                style={{ width: "100%" }}
                onClick={() => {
                  handleClose();
                  if (option.isUpdate) {
                    onClickActionEditar(item ?? null);
                  } else {
                    option.onClick(item ?? null);
                  }
                }}
              >
                {option.icon && <ListItemIcon>{option.icon}</ListItemIcon>}
                <ListItemText
                  style={{ fontSize: "12px" }}
                  primary={option.descripcion}
                />
              </ListItem>
            ))}
          </Menu>
        </div>
      );
    }
    return "N/A";
  };

  /**
   * Retorna la lista de acciones de la tabla
   * @param {*} item
   * @returns
   */
  const getTableActions = (item, index) => {
    return (
      <ButtonGroup
        variant="text"
        size="large"
        className="btngrp"
        color="primary"
        orientation={`${matches ? `horizontal` : `vertical`}`}
      >
        {tableActions &&
          Array.isArray(tableActions) &&
          tableActions.map((act, key) => {
            if (!act.listActions) {
              return (
                <Button
                  key={key}
                  id={`action_btn_${index}`}
                  onClick={() =>
                    act.isUpdate
                      ? onClickActionEditar(item)
                      : act.onClick
                      ? act.onClick(item ? item : null)
                      : null
                  }
                >
                  {act.icon}
                </Button>
              );
            } else {
              return getActionMenuTable(act, item);
            }
          })}
      </ButtonGroup>
    );
  };

  /**
   * Accción al presionar boton enviar del modal editar
   * @param {*} form
   */
  const onSubmitIngresar = (form) => {
    queryIngresar.mutate(form);
  };

  if (hanleOnClickGuardarIngresar && queryIngresar.isSuccess) {
    hanleOnClickGuardarIngresar(queryIngresar?.data?.respuesta);
  }

  /**
   * Accción al presionar boton enviar del modal editar
   * @param {*} form
   */
  const onSubmitEditar = (form) => {
    form.id = selectedItem.id;
    queryActualizar.mutate(form);
  };

  useEffect(() => {
    if (hanleOnClickGuardarEditar && queryActualizar.isSuccess) {
      hanleOnClickGuardarEditar(queryActualizar?.data?.respuesta);
    }
  }, [queryActualizar?.isLoading]);

  /**
   * Acción al presionar el boton filtrar
   * @param {*} form
   */
  const onSubmitFilterFunction = (form) => {
    if (forceMinFilters) {
      const varDefaultIgnore = ["orderByAsc", "normalPaginate"];
      const flag = Object.keys(form).some((value, key) => {
        if (
          minFiltersToIgnore.includes(value) ||
          varDefaultIgnore.includes(value)
        ) {
          return false;
        }
        return (
          form[value] !== null &&
          form[value] !== undefined &&
          form[value] !== ""
        );
      });
      if (!flag) {
        helpers.alert.confirmAlert(
          "Error",
          "Debe ingresar al menos un criterio de búsqueda",
          "warning",
          false
        );
        return;
      }
    }

    setFiltrado(true);
    if (handleOnSubmitFilter) handleOnSubmitFilter(form);
    if (simplePaginate) setShowSimplePagination(!!!form.normalPaginate);
    setFilterParams(
      getFilterParams(camposFilter, 1, paginationOptions.perPage, form)
    );
    setSelected({});
    setPaginationOptions({
      ...paginationOptions,
      filterParams,
      currentPage: 1,
    });
  };

  const handleChangePage = (event, newPage) => {
    setFiltrado(true);
    setSelected({});
    setPaginationOptions({
      ...paginationOptions,
      filterParams,
      currentPage: newPage,
    });
  };

  const handleExpandFilters = () => {
    setExpandedFilters(!expandedFilters);
  };

  /**
   * Muestra una alerta de confirmación indicando que los campos en el formulario
   * han sido cambiados y que se perderan si cierra el modal
   * @returns
   */
  const showConfirmFormChangedData = () => {
    return new Promise((resolve) => {
      helpers.alert
        .confirmAlert(
          "¿Quieres continuar?",
          "Estás a punto de cerrar esta ventana y perderas los datos que hayas ingresado o editado.",
          "warning"
        )
        .then((res) => {
          if (res) {
            setOpenEditarModal(false);
            setOpenIngresarModal(false);
          }
          resolve(res);
        });
    });
  };

  let tableData = null;

  if (query && query.isSuccess) {
    let tableHeadersClone = helpers.object.cloneObjectArray(tableHeaders);
    if (hasCheckbox) {
      tableHeadersClone.unshift({
        name: "",
        // countItems <= rowsPerPage && (
        //   <Checkbox
        //     color='primary'
        //     onChange={(event) => handleSelectAllClick(event)}
        //     checked={datosSelected.length == countItems}
        //     indeterminate={
        //       datosSelected.length > 0 && datosSelected.length < countItems
        //     }
        //   />
        // )
      });
    }
    tableData = {
      columns: tableHeadersClone,
      rows:
        query.data.success?.descripcionRespuesta?.data || query.data?.data
          ? /* queryListData.data && queryListData.data.data ? */ getTableRows()
          : [],
    };
  }

  /**
   * Metodo que se ejecuta cuando se cierra el modal de ingresar o editar
   */
  const onCloseModal = () => {
    if (changedFormEdit) {
      return showConfirmFormChangedData();
    } else {
      setOpenEditarModal(false);
      setOpenIngresarModal(false);
    }
  };

  /**
   * En caso de no encontrar registros, Muestra una alerta indicando que la tabla no tiene datos
   */
  const showAlerTableNotContent = () => {
    if (query.isLoading) {
      return (
        <Grid item xs={12}>
          <Alert severity="info" sx={{ fontFamily: "Montserrat" }}>
            Cargando...
          </Alert>
        </Grid>
      );
    }
    if (!query.isLoading && tableData && tableData.rows.length == 0) {
      return (
        <Grid item xs={12}>
          <Alert severity="warning" sx={{ fontFamily: "Montserrat" }}>
            No hay registros para mostrar
          </Alert>
        </Grid>
      );
    }

    if (!query.isLoading && query.data && query.data.data) {
      return (
        <Grid item xs={12}>
          <Alert severity="error" sx={{ fontFamily: "Montserrat" }}>
            Formato no valido
          </Alert>
        </Grid>
      );
    }

    if (!query.isLoading && query.error ) {
      return (
        <Grid item xs={12}>
          <Alert severity="info" sx={{ fontFamily: "Montserrat" }}>
            {query.error.response.data.error.detalleRespuesta.mensaje}
          </Alert>
        </Grid>
      );
    }

    /*  if (queryListData && queryListData.isIdle) {
      return (
        <Grid xs={12}>
          <Alert severity='info'>
            Realice un filtro para encontrar resultados.
          </Alert>
        </Grid>
      );
    } */
    return "";
  };

  const getCell = (row) => {
    if (row?.tooltip?.largo && row?.data?.length > row.tooltip.largo) {
      var caracteres = 0;
      return (
        <Tooltip
          placement={row?.tooltip?.placement ?? "top"}
          title={
            <div style={row.tooltip.estilo}>
              {row.data.split("<endln>").map((linea) => {
                if (caracteres === 0 && linea.length > 300) {
                  caracteres += linea.length;
                  return (
                    <div>
                      {helpers.string.truncateString(
                        linea,
                        300,
                        row.tooltip.separador,
                        ""
                      )}
                    </div>
                  );
                }
                caracteres = caracteres + linea.length;
                if (caracteres <= 300) {
                  return (
                    <div>
                      {linea}
                      <br />
                    </div>
                  );
                }
              })}
              {caracteres > 300 ? "..." : null}
            </div>
          }
          arrow
          enterTouchDelay={0}
        >
          <div>
            {helpers.string.truncateString(
              row.data.split("<endln>").join(" "),
              row.tooltip.largo,
              row.tooltip.separador,
              row.tooltip.textoFinal
            )}
          </div>
        </Tooltip>
      );
    } else {
      return typeof row?.data === "string"
        ? row?.data?.split("<endln>")?.join(" ")
        : row?.data;
    }
  };

  // Mostrar modal con filtros
  const onClickShowModalFilter = () => {
    setShowModalFilter(true);
  };

  // Cierre el modal de filtros
  const onCloseModalFilter = () => {
    setShowModalFilter(false);
  };

  return (
    <Box pb={2}>
      {openModalEditar && (
        <CustomModal
          callbackOnClose={() => {
            setChangedFormEdit(false);
            if (onCloseModalEditarInsertar) {
              onCloseModalEditarInsertar();
            }
          }}
          fullWidth={true}
          isModalOpened={openModalEditar}
          handleCloseModal={() => setOpenEditarModal(false)}
          onClose={onCloseModal}
          title={titleModalEditar}
          body={getBodyModal(onSubmitEditar, selectedItem)}
          showOk={false}
          showCancel={true}
          maxWidth="md"
          id="modalEditar"
        />
      )}

      {showFilterSection &&
        camposFilter &&
        !helpers.array.isEmpty(camposFilter) && (
          <FilterSection
            expandedFilters={expandedFilters}
            handleExpandFilters={handleExpandFilters}
            filterSeccionTitle={filterSeccionTitle}
            onSubmitFilterFunction={onSubmitFilterFunction}
            camposFilter={camposFilter}
            filterButtonText={filterButtonText}
            tooltipFilterBtn={tooltipFilterBtn}
            preventSubmitOnFilter={preventSubmitOnFilter}
            showModalFilter={showModalFilter}
            onCloseModalFilter={onCloseModalFilter}
            screenSize={size}
            mobileScreenSize={mobileScreenSize}
            handleDeshacerFilter={handleDeshacerFilter}
            simplePaginate={simplePaginate}
            orderByFilter={orderByFilter}
          />
        )}

      <Grid container>
        {showBtnIngresar && (
          <Grid item>
            <Box pb={2} pr={2}>
              {openModalIngresar && (
                <CustomModal
                  isModalOpened={openModalIngresar}
                  handleCloseModal={() => setOpenIngresarModal(false)}
                  onClose={onCloseModal}
                  body={getBodyModal(onSubmitIngresar)}
                  title={titleModalIngresar}
                  showOk={false}
                  id="modalIngresar"
                  showCancel={true}
                  fullWidth="md"
                  maxWidth="md"
                  callbackOnClose={(res) => {
                    setChangedFormEdit(false);
                    if (onCloseModalEditarInsertar) {
                      onCloseModalEditarInsertar(res);
                    }
                  }}
                />
              )}
              <Tooltip title={titleBtnIngresar}>
                <Fab
                  id="btnModal_agregarsss"
                  size="small"
                  color="primary"
                  aria-label="add"
                  onClick={() => {
                    setOpenIngresarModal(true);
                    setModalSeHaAbierto(true);
                  }}
                >
                  <AddIcon />
                </Fab>
              </Tooltip>
            </Box>
          </Grid>
        )}
        {showFilterSection && size[0] <= mobileScreenSize && (
          <Grid item>
            <Box mb={2}>
              <Tooltip title={titleIconFilter}>
                <Fab
                  id="btnModalFiltrarModal"
                  size="small"
                  color="primary"
                  onClick={onClickShowModalFilter}
                >
                  <FilterAltIcon />
                </Fab>
              </Tooltip>
            </Box>
          </Grid>
        )}

        {showExportBtn && tableData && (
          <Grid item>
            <Box pl={2} mb={2}>
              <Tooltip title={titleExport}>
                <Fab
                  id="btnModal_agregar"
                  size="small"
                  color="primary"
                  aria-label="add"
                  onClick={onClickExportExcel}
                >
                  <FileDownloadIcon />
                </Fab>
              </Tooltip>
            </Box>
          </Grid>
        )}

        {tableData && tableData.rows.length > 0 && query.status !== "idle" ? (
          <>
            <Grid item xs={12}>
              {query.isSuccess && (
                <TableContainer component={Paper}>
                  <Table aria-label="simple table" size="small">
                    <TableHead
                      sx={{
                        backgroundColor: "#00657d",
                        fontFamily: "Montserrat",
                      }}
                    >
                      <TableRow>
                        {!helpers.array.isEmpty(tableData.columns) &&
                          tableData.columns.map((column, columnKey) => (
                            <TableCell
                              key={`column_${columnKey}`}
                              align={column.position ? column.position : "left"}
                              sx={{ color: "#FFFF" }}
                            >
                              {column.name}
                            </TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableData.rows.map((row, rowKey) => (
                        <TableRow
                          key={`row_${rowKey}`}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          {tableData.columns.map((column, columnKey) => (
                            <TableCell
                              key={`cell_${columnKey}`}
                              align={row[columnKey].position ?? "left"}
                              style={{
                                backgroundColor:
                                  row[columnKey]?.backgroundColor ?? "",
                                color: row[columnKey]?.color ?? "",
                              }}
                            >
                              {row[columnKey].onClick ? (
                                <Link
                                  component="button"
                                  variant="body2"
                                  underline={row[columnKey].underline ?? "none"} // hover | none | always
                                  onClick={() =>
                                    row[columnKey].onClick
                                      ? row[columnKey].onClick(
                                          row[columnKey].data
                                        )
                                      : null
                                  }
                                >
                                  {row[columnKey].data}
                                </Link>
                              ) : (
                                getCell(row[columnKey])
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Grid>

            {paginate && (
              <>
                <Grid
                  item
                  xs={12}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Box pt={2}>
                    {simplePaginate && showSimplePagination ? (
                      <SimplePagination
                        prev={
                          query?.data?.success.descripcionRespuesta
                            ?.prev_page_url
                            ? query?.data?.prev_page_url
                            : null
                        }
                        next={
                          query?.data?.success.descripcionRespuesta
                            ?.next_page_url
                            ? query?.data?.next_page_url
                            : null
                        }
                        paginationOptions={paginationOptions}
                        handleChangePage={handleChangePage}
                      />
                    ) : (
                      <Pagination
                        onChange={handleChangePage}
                        count={countPages}
                        size="large"
                        showFirstButton
                        showLastButton
                        page={paginationOptions.currentPage}
                      />
                    )}
                  </Box>
                </Grid>

                {showTotalItems &&
                  (!simplePaginate || !showSimplePagination) && (
                    <Grid
                      item
                      xs={12}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Box
                        sx={{
                          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                        }}
                      >
                        <b>Total:</b> {countItems} registros.
                      </Box>
                    </Grid>
                  )}
              </>
            )}
          </>
        ) : (
          showAlerTableNotContent()
        )}
      </Grid>
    </Box>
  );
};
export default CustomTable;
